import { render } from "./CollaborationNavIcon.vue?vue&type=template&id=1ae9cf4b"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__